/**
 * tdesign v1.11.4
 * (c) 2025 tdesign
 * @license MIT
 */

import { isVNode, Fragment, h } from 'vue';
import { isObject, isString, isArray, camelCase, kebabCase, isFunction, isEmpty } from 'lodash-es';

function getDefaultNode(options) {
  var defaultNode;
  if (isObject(options) && "defaultNode" in options) {
    defaultNode = options.defaultNode;
  } else if (isVNode(options) || isString(options)) {
    defaultNode = options;
  }
  return defaultNode;
}
function getChildren(content) {
  var childList = [];
  var _innerGetChildren = function innerGetChildren(content2) {
    if (!isArray(content2)) return;
    content2.forEach(function (item) {
      if (item.children && isArray(item.children)) {
        if (item.type !== Fragment) return;
        _innerGetChildren(item.children);
      } else {
        childList.push(item);
      }
    });
    return childList;
  };
  return _innerGetChildren(content);
}
function getParams(options) {
  return isObject(options) && "params" in options ? options.params : {};
}
function getSlotFirst(options) {
  return isObject(options) && "slotFirst" in options ? options.slotFirst : false;
}
function handleSlots(instance, params, name) {
  var _instance$$slots$came, _instance$$slots, _instance$$slots$keba, _instance$$slots2;
  var node = (_instance$$slots$came = (_instance$$slots = instance.$slots)[camelCase(name)]) === null || _instance$$slots$came === void 0 ? void 0 : _instance$$slots$came.call(_instance$$slots, params);
  if (node) return node;
  node = (_instance$$slots$keba = (_instance$$slots2 = instance.$slots)[kebabCase(name)]) === null || _instance$$slots$keba === void 0 ? void 0 : _instance$$slots$keba.call(_instance$$slots2, params);
  if (node) return node;
  return null;
}
var renderTNodeJSX = function renderTNodeJSX(instance, name, options) {
  var params = getParams(options);
  var defaultNode = getDefaultNode(options);
  var propsNode;
  if (name in instance) {
    propsNode = instance[name];
  }
  if (propsNode === false || propsNode === null) return;
  if (propsNode === true && defaultNode) {
    return handleSlots(instance, params, name) || defaultNode;
  }
  if (isFunction(propsNode)) return propsNode(h, params);
  var isPropsEmpty = [void 0, params, ""].includes(propsNode);
  if (isPropsEmpty && (instance.$slots[camelCase(name)] || instance.$slots[kebabCase(name)])) {
    return handleSlots(instance, params, name);
  }
  return propsNode;
};
var renderTNodeJSXDefault = function renderTNodeJSXDefault(vm, name, options) {
  var defaultNode = getDefaultNode(options);
  return renderTNodeJSX(vm, name, options) || defaultNode;
};
var renderContent = function renderContent(vm, name1, name2, options) {
  var params = getParams(options);
  var defaultNode = getDefaultNode(options);
  var toParams = params ? {
    params: params
  } : void 0;
  var node1 = renderTNodeJSX(vm, name1, toParams);
  var node2 = renderTNodeJSX(vm, name2, toParams);
  var res = isEmpty(node1) ? node2 : node1;
  return isEmpty(res) ? defaultNode : res;
};

export { getChildren, getDefaultNode, getParams, getSlotFirst, handleSlots, renderContent, renderTNodeJSX, renderTNodeJSXDefault };
//# sourceMappingURL=render-tnode.mjs.map
